// Note: Remove require packages in package.json if exported as external modules
import axiosAuthHttp from './axios-auth-http';


const bindHandlers = (requester, handlers) => {
  if (handlers == null) {
    return;
  }

  const successHandlerNamesMap = {
    request: 'onRequestSuccess',
    response: 'onResponseSuccess',
  };

  // eslint-disable-next-line
  for (const interceptorTypeName in successHandlerNamesMap) {
    const handler = handlers[successHandlerNamesMap[interceptorTypeName]];

    requester.interceptors[interceptorTypeName].use(
      (success) => {
        if (handler != null) {
          handler(success);
        }

        return success;
      },
      (error) => {
        if (handlers.onError != null) {
          handlers.onError(error);
          return null;
        }

        return Promise.reject(error);
      }
    );
  }
};

const getTokenOptions = (requesterType) => {
  switch (requesterType) {
    case 'CMS_WEB_SERVICE':
      return {
        name: process.env.VUE_APP_API_KEY_TOKEN_NAME,
        salt: process.env.VUE_APP_API_KEY_TOKEN_SALT,
        ttl: process.env.VUE_APP_API_KEY_TOKEN_TTL,
        body: {
          API_KEY: process.env.VUE_APP_API_KEY_VALUE,
        },
      };
    default:
      return null;
  }
};

class HttpUtils {
  // eslint-disable-next-line object-curly-newline
  createRequester ({ baseUrl, headers, requesterType, onRequestSuccess, onResponseSuccess, onError }) {
    const requester = axiosAuthHttp.create({
      baseUrl,
      headers,
      token: getTokenOptions(requesterType),
    });

    bindHandlers(requester, {
      onRequestSuccess,
      onResponseSuccess,
      onError,
    });

    return requester;
  }
}

export default new HttpUtils();
